import { PayloadAction } from '@reduxjs/toolkit'
import {
  EAuctionStrategy,
  EBudgetStrategy,
  EPacing,
  EPricingStrategy,
  ICampaignFrequency,
} from '@unfoldrtech/portal-mic'
import { ICampaign } from '../../../models/interfaces/ICampaignState'
import { WritableDraft } from 'immer/dist/internal'

const setCampaignSettings = (
  state: WritableDraft<ICampaign>,
  action: PayloadAction<{
    startDate: string
    endDate?: string | null
    budget: number
    auctionStrategy?: EAuctionStrategy
    pricingStrategy?: EPricingStrategy
    frequency?: ICampaignFrequency
    pacing?: EPacing
    isLifetimeBudget?: boolean
    budgetStrategy?: EBudgetStrategy
  }>
) => {
  state.startDate = action.payload.startDate
  if (action.payload.endDate !== undefined) {
    state.endDate = action.payload.endDate
  }
  state.budget = action.payload.budget
  state.auctionStrategy = action.payload.auctionStrategy
  state.pricingStrategy = action.payload.pricingStrategy
  state.frequency = action.payload.frequency || undefined
  if (action.payload.pacing) {
    state.pacing = action.payload.pacing
  }
  if (action.payload.isLifetimeBudget !== undefined) {
    state.isLifetimeBudget = action.payload.isLifetimeBudget
  }
  if (action.payload.budgetStrategy !== undefined) {
    state.budgetStrategy = action.payload.budgetStrategy
  }
}

export default setCampaignSettings
